import { Button } from '@mui/material'
import { UIModal } from 'features/UI'
import { useShowControl } from 'hooks/useShowControl'
import React from 'react'
import { useTeams } from '../../hooks/useTeams'
import { TimelineTeamMemberFormAdd } from './TimelineTeamMemberFormAdd'

export function TimelineTeamMemberControlAdd() {
  const { activeTeamId } = useTeams()
  const [isOpen, handleOpen, handleClose] = useShowControl()

  return (
    <>
      <Button
        variant="contained"
        sx={{ width: '120px' }}
        disabled={activeTeamId === null}
        onClick={handleOpen}
      >
        Add Member
      </Button>

      <UIModal title="Add Member" width={800} isOpen={isOpen} onClose={handleClose}>
        <TimelineTeamMemberFormAdd onClose={handleClose} />
      </UIModal>
    </>
  )
}
